import React from "react";
import { Button } from "@mui/material";
import { alpha, lighten } from "@mui/material/styles";

const SavyButton = React.forwardRef(function SavyButton(
  {
    children,
    color = "primary",
    variant = "contained",
    disabled = false,
    sx,
    ...props
  },
  ref
) {
  return (
    <Button
      {...props}
      disableElevation
      ref={ref}
      color={color}
      variant={variant}
      disabled={disabled}
      sx={[
        (theme) => {
          const paletteColor = theme.palette[color];
          const mainColor = paletteColor?.main || theme.palette.text.primary;
          const containedColor =
            paletteColor?.main ||
            theme.palette.grey[theme.palette.mode === "dark" ? 800 : 300];

          return {
            textTransform: "none",
            boxShadow: "none",
            "&:hover, &:active, &.Mui-focusVisible": {
              boxShadow: "none",
            },
            transition:
              "transform 280ms cubic-bezier(0.34, 1.56, 0.64, 1), background-color 180ms ease, color 180ms ease",
            ...(!disabled && {
              "@media (hover: hover)": {
                "&:hover": {
                  backgroundColor:
                    variant === "contained"
                      ? lighten(containedColor, 0.08)
                      : alpha(mainColor, 0.1),
                  ...(variant !== "contained" && {
                    color: paletteColor?.dark || "inherit",
                  }),
                },
              },
              "&:active": {
                transform: "scale(0.97, 0.94)",
                transition:
                  "transform 90ms ease-out, background-color 180ms ease, color 180ms ease",
              },
            }),
            "@media (prefers-reduced-motion: reduce)": {
              transition: "none",
              "&:active": {
                transform: "none",
                transition: "none",
              },
            },
            "&.Mui-focusVisible": {
              boxShadow: "none",
              outline: `2px solid ${alpha(mainColor, 0.65)}`,
              outlineOffset: 3,
            },
          };
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Button>
  );
});

export default SavyButton;
